export default __webpack_public_path__ + "static/media/redmask.ea681c40.png";